module.exports = __webpack_public_path__ + "img/jeffrey.4b98e169.jpg";